import React from "react";

const TYPE_STYLES = {
  success: { background: "#dcfce7", color: "#15803d" },
  error:   { background: "#fee2e2", color: "#b91c1c" },
  info:    { background: "#dbeafe", color: "#1d4ed8" },
  default: {},
};

const Badge = React.memo(function Badge({ children, type }) {
  const extra = TYPE_STYLES[type] || TYPE_STYLES.default;
  return (
    <span className="badge" style={extra}>
      {children}
    </span>
  );
});

export default Badge;
